import { ReactNode } from "react";
import QuickViewDetail from "../QuickViewDetail";
import { Styles } from "./styled";

type WrapperDetailProps = {
  children?: ReactNode;
  isShowQuickView: boolean;
  isOpen?: boolean;
  onClose?: () => void;
  handleViewDetail?: () => void;
  handleViewEdit?: () => void;
  handleViewMode?: () => void;
  btnGroup?: ReactNode;
  disabledBtnView?: boolean;
  disabledBtnEdit?: boolean;
  containerClassName?: string;
  hideScrollbar?: boolean;
  hideScroll?: boolean;
  containerHeight?: number | string;
  quickButtonDirection?: "vertical" | "horizontal";
};
const WrapperDetail = ({
  children,
  isShowQuickView,
  isOpen,
  onClose,
  btnGroup,
  containerClassName,
  ...quickViewDetailProps
}: WrapperDetailProps) => {
  if (!isShowQuickView) {
    return (
      <Styles>
        {btnGroup && <div className="group-btn">{btnGroup}</div>}
        <div className={`container-wrapper ${containerClassName || ""}`}>
          {children}
        </div>
      </Styles>
    );
  }

  return (
    <QuickViewDetail
      isOpen={isOpen || false}
      onClose={() => onClose?.()}
      {...quickViewDetailProps}
    >
      {children}
    </QuickViewDetail>
  );
};
export default WrapperDetail;
